const data = {
  tmc: [
    {
      avatar: '',
      name: '房晓乐',
      company: '平凯星辰',
      title: '互联网首席架构师',
    },
    {
      avatar: '',
      name: '黄潇',
      company: '美团',
      title: 'DBA',
    },
  ],

  leader: [
    {
      avatar: '',
      name: '刘春雷',
      company: '58 同城',
      title: 'DBA',
      role: '内容组 Leader',
    },
    {
      avatar: '',
      name: '徐嘉埥',
      company: '建信金科',
      title: '数据库研发',
      role: '内容组 Co-Leader',
    },
    {
      avatar: '',
      name: '王志广',
      company: 'bilibili',
      title: 'DBA',
      role: '内容组 Co-Leader',
    },
    {
      avatar: '',
      name: '田朋',
      company: '京东科技',
      title: 'DBA',
      role: '宣传组 Co-Leader',
    },
    {
      avatar: '',
      name: '胡国青',
      company: '',
      title: '数据库讲师',
      role: '宣传组 Co-Leader',
    },
    {
      avatar: '',
      name: '代晓磊',
      company: '360',
      title: '智慧商业数据库运维高级专家',
      role: '华北组 Leader',
    },
    {
      avatar: '',
      name: '靳献旗',
      company: '汽车之家',
      title: '高级 DBA',
      role: '华北组 Co-Leader',
    },
    {
      avatar: '',
      name: '赵海军',
      company: '理想汽车',
      title: '数据库负责人',
      role: '华北组 Co-Leader',
    },
    {
      avatar: '',
      name: '闫晓宇',
      company: '得物',
      title: 'DBA Leader',
      role: '华东组 Leader',
    },
    {
      avatar: '',
      name: '罗瑞星',
      company: '百胜中国',
      title: 'IT 大数据经理',
      role: '华东组 Co-Leader',
    },
    {
      avatar: '',
      name: '杨漆',
      company: '太平人寿保险总公司',
      title: '关系型数据库管理岗',
      role: '华东组 Co-Leader',
    },
    {
      avatar: '',
      name: '唐万民',
      company: '多点',
      title: 'RDBMS 数据库组负责人',
      role: '西南组 Leader',
    },
    {
      avatar: '',
      name: '胡盼盼',
      company: '微众银行',
      title: '数据库平台负责人',
      role: '华南组 Leader',
    },
    {
      avatar: '',
      name: '田维繁',
      company: '网易游戏',
      title: 'DBA',
      role: '华南组 Co-Leader',
    },
    {
      avatar: '',
      name: '黄蔚',
      company: '微众银行',
      title: '高级 DBA',
      role: '华南组 Co-Leader',
    },
    {
      avatar: '',
      name: 'Neil Han',
      company: '平凯星辰',
      title: 'Head of APAC',
      role: 'APAC 区域组 Leader',
    },
  ],

  adviser: [
    {
      avatar: '',
      name: '孙晓光',
      company: '平凯星辰 Community Development',
      title: '团队负责人',
      role: (
        <>
          TUG 2019 北京区 Leader
          <br />
          TUG 顾问团成员
        </>
      ),
    },
    {
      avatar: '',
      name: '侯圣文',
      company: '贝壳找房',
      title: '基础平台总监',
      role: 'TUG 顾问团成员',
    },
    {
      avatar: '',
      name: '贾世闻',
      company: '京东云',
      title: '交付部架构师',
      role: 'TUG 顾问团成员',
    },
    {
      avatar: '',
      name: '赵仕庆',
      company: '京东科技',
      title: '研发工程师',
      role: 'TUG 顾问团成员',
    },
    {
      avatar: '',
      name: '代晓磊',
      company: '360',
      title: '智慧商业数据库运维高级专家',
      role: (
        <>
          TUG 顾问团成员
          <br />
          华北组 Leader
        </>
      ),
    },
  ],
};

export default data;
